import { FunctionComponent } from "react";
import Select from "react-select";
import { TVChannel } from "../../../../api/tvChannelApi";
import { Button } from "../../../components/Button";
import { FormInput, FormRow, FormRowWithColumns } from "../../../components/formRow/FormRow";
import { RightModal } from "../../../components/sideModal/Modal";
import { StreamEditFields } from "./useStreamEdit";

interface Props {
    show: boolean;
    onClose: () => void;
    onSave: () => void;
    tvChannelsList: TVChannel[];
    fields: StreamEditFields;
}

const EditStreamModal: FunctionComponent<Props> = ({ show, onClose, onSave, tvChannelsList, fields }) => {
    const {
        editStreamName, setEditStreamName,
        isEditStreamNameError, setIsEditStreamNameError,
        editStartTime, setEditStartTime,
        editEndTime, setEditEndTime,
        isEditStartDateError, setIsEditStartDateError,
        isEditEndDateError, setIsEditEndDateError,
        isEditStreamPeriodError,
        editSeries, setEditSeries,
        editSeason, setEditSeason,
        editEpisode, setEditEpisode,
        editTitle, setEditTitle,
        editIabCat, setEditIabCat,
        editGenre, setEditGenre,
        editRating, setEditRating,
        editTvChannel,
    } = fields;

    return (
        <RightModal title="Edit Priority Stream" wide={true} show={show} onRequestClose={onClose}>
            <FormRow>
                <FormInput
                    errorMessage="Please enter name"
                    id="edit_stream_name_input"
                    isError={isEditStreamNameError}
                    title="Stream Name"
                    onChangeValue={(v) => { setEditStreamName(v); setIsEditStreamNameError(false); }}
                    value={editStreamName}
                />
            </FormRow>
            <FormRowWithColumns>
                <FormRow>
                    <FormInput
                        errorMessage="Please select Start Time"
                        id="edit_stream_start_time"
                        isError={isEditStartDateError}
                        type="datetime-local"
                        onChangeValue={(v) => { setIsEditStartDateError(false); setEditStartTime(v); }}
                        value={editStartTime}
                        title="Start Time"
                    />
                </FormRow>
                <FormRow>
                    <FormInput
                        errorMessage="Please select End Time"
                        id="edit_stream_end_time"
                        isError={isEditEndDateError}
                        type="datetime-local"
                        onChangeValue={(v) => { setIsEditEndDateError(false); setEditEndTime(v); }}
                        value={editEndTime}
                        title="End Time"
                    />
                    {isEditStreamPeriodError && <span className="error">End Time should be later than Start Time</span>}
                </FormRow>
            </FormRowWithColumns>
            <FormRow>
                <label>TV Channel</label>
                <Select
                    classNamePrefix="select"
                    isClearable={false}
                    isDisabled={true}
                    options={tvChannelsList}
                    getOptionLabel={(option) => `${option.name}`}
                    getOptionValue={(option) => `${option.id}`}
                    onChange={() => {}}
                    value={editTvChannel}
                />
            </FormRow>
            <FormRowWithColumns>
                <FormRow><FormInput errorMessage="" id="edit_series" isError={false} title="Series" onChangeValue={setEditSeries} value={editSeries} /></FormRow>
                <FormRow><FormInput errorMessage="" id="edit_season" isError={false} title="Season" onChangeValue={setEditSeason} value={editSeason} /></FormRow>
                <FormRow><FormInput errorMessage="" id="edit_episode" isError={false} title="Episode" onChangeValue={setEditEpisode} value={editEpisode} /></FormRow>
                <FormRow><FormInput errorMessage="" id="edit_title" isError={false} title="Title" onChangeValue={setEditTitle} value={editTitle} /></FormRow>
            </FormRowWithColumns>
            <FormRowWithColumns>
                <FormRow><FormInput errorMessage="" id="edit_iab_cat" isError={false} title="IAB Cat" onChangeValue={setEditIabCat} value={editIabCat} /></FormRow>
                <FormRow><FormInput errorMessage="" id="edit_genre" isError={false} title="Genre" onChangeValue={setEditGenre} value={editGenre} /></FormRow>
                <FormRow><FormInput errorMessage="" id="edit_rating" isError={false} title="Rating" onChangeValue={setEditRating} value={editRating} /></FormRow>
            </FormRowWithColumns>
            <div className="modal-btn-group">
                <Button color="green" label="Save" onClick={onSave} />
                <Button color="gray" label="Cancel" onClick={onClose} />
            </div>
        </RightModal>
    );
};

export default EditStreamModal;
